export const ADULT = 'ADULT';
export const CHILD = 'CHILD';
export const INFANT = 'INFANT';
export const STUDENT = 'STUDENT';
export const SENIOR = 'SENIOR';



// WEBPACK FOOTER //
// ./src/domain/age.js